import moment from 'moment';
import { formatDate } from '../../utils';

const Messages = ({ groupedMessages }) => {
    const getFormattedDate = (dateStr) => {
        const today = moment().format('YYYY-MM-DD');
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');

        if (dateStr === today) return '오늘';
        if (dateStr === yesterday) return '어제';
        return formatDate(dateStr);
    };
    return (
        <>
            {Object.entries(groupedMessages).map(([date, messages], index) => (
                <div key={index} className="msg__group-date">
                    <div className="msg__date">{getFormattedDate(date)}</div>
                    {messages.map((item, idx) => {
                        const prevItem = idx > 0 ? messages[idx - 1] : null;
                        const isSameTypeAsPrev = prevItem && prevItem.type === item.type;

                        const nextItem = idx < messages.length - 1 ? messages[idx + 1] : null;
                        const isSameTypeAsNext = nextItem && nextItem.type === item.type;

                        return item.type === 'SEND' ? (
                            <div key={idx} className="msg__me">
                                <div className="msg__me-rt">
                                    <div
                                        className={`msg__me-ans ${!isSameTypeAsPrev ? 'msg__me-arrow' : ''}`}
                                        style={{ whiteSpace: 'pre-line' }}
                                    >
                                        {item.contents}
                                    </div>
                                    <div className={`msg__me-date ${isSameTypeAsNext ? 'msg__me-date--hover' : ''}`}>
                                        {moment(item.sendDate).format('HH:mm:ss')}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div key={idx} className="msg__you">
                                {!isSameTypeAsPrev ? (
                                    <div className="msg__you-name">
                                        {item.fromMemberGbn === 'C'
                                            ? item.fromBizCompany
                                            : item.fromMemberGbn === 'P'
                                            ? item.fromNameKor
                                            : ''}
                                    </div>
                                ) : (
                                    <div className="msg__you-blank">
                                        {item.fromMemberGbn === 'C'
                                            ? item.fromBizCompany
                                            : item.fromMemberGbn === 'P'
                                            ? item.fromNameKor
                                            : ''}
                                    </div>
                                )}
                                <div className="msg__you-rt">
                                    <div
                                        className={`msg__you-ans ${!isSameTypeAsPrev ? 'msg__you-arrow' : ''}`}
                                        style={{ whiteSpace: 'pre-line' }}
                                    >
                                        {item.contents}
                                    </div>
                                    <div className={`msg__you-info ${isSameTypeAsNext ? 'msg__you-info--hover' : ''}`}>
                                        <div className="msg__you-date">{moment(item.sendDate).format('HH:mm:ss')}</div>
                                        {!isSameTypeAsNext && (
                                            <div className="msg__you-read">
                                                {item.readed === 'Y' ? '읽음' : '읽지 않음'}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </>
    );
};

export default Messages;
